(function () {
  'use strict';

  var STORAGE = 'lemannyCaseIdV2';
  var JOURNEY_STORAGE = 'lemannyCaseIdJourneyV1';
  var JOURNEY_EVENTS_STORAGE = 'lemannyCaseIdJourneyEventsV1';
  var LEAD_EMAIL = 'lojalemanny@gmail.com';
  var ORDER = ['titan', 'signature', 'urban', 'pure'];

  var PROFILES = {
    titan: {
      icon: '🛡️',
      name: 'TITAN',
      description: 'Você prioriza proteção acima de tudo. Ideal para quem possui rotina intensa e quer máxima segurança.'
    },
    signature: {
      icon: '✨',
      name: 'SIGNATURE',
      description: 'Você busca elegância, acabamento premium e sofisticação.'
    },
    urban: {
      icon: '⚖️',
      name: 'URBAN',
      description: 'Você procura equilíbrio entre estilo e proteção para o dia a dia.'
    },
    pure: {
      icon: '🤍',
      name: 'PURE',
      description: 'Você prefere preservar o design original do celular com proteção discreta.'
    }
  };

  var QUESTIONS = {
    2: {
      title: 'O que é mais importante para você?',
      options: [
        ['🛡️', 'Máxima proteção', 'protection'],
        ['✨', 'Design elegante', 'elegance'],
        ['⚖️', 'Equilíbrio entre proteção e estilo', 'balance'],
        ['🤍', 'Mostrar o visual original do celular', 'original']
      ]
    },
    3: {
      title: 'Como é sua rotina?',
      options: [
        ['🏢', 'Trabalho, faculdade ou uso diário', 'daily'],
        ['🚶', 'Estou sempre em movimento', 'movement'],
        ['✈️', 'Viajo com frequência', 'travel'],
        ['🏋️', 'Tenho uma rotina intensa', 'intense']
      ]
    },
    4: {
      title: 'Qual estilo combina mais com você?',
      options: [
        ['🖤', 'Minimalista', 'minimal'],
        ['✨', 'Sofisticado', 'sophisticated'],
        ['🔥', 'Moderno', 'modern'],
        ['🎨', 'Gosto de chamar atenção', 'different']
      ]
    },
    5: {
      title: 'Se pudesse escolher apenas uma característica:',
      options: [
        ['🛡️', 'Resistência', 'resistance'],
        ['📸', 'Proteção para câmera', 'camera'],
        ['🤲', 'Pegada confortável', 'grip'],
        ['✨', 'Acabamento premium', 'finish']
      ]
    }
  };

  var POINTS = {
    2: { protection: { titan: 3 }, elegance: { signature: 3 }, balance: { urban: 3 }, original: { pure: 3 } },
    3: { daily: { urban: 2 }, movement: { urban: 1, titan: 1 }, travel: { signature: 1, urban: 1 }, intense: { titan: 2 } },
    4: { minimal: { pure: 2 }, sophisticated: { signature: 2 }, modern: { urban: 2 }, different: { signature: 1, urban: 1 } },
    5: { resistance: { titan: 2 }, camera: { titan: 1, signature: 1 }, grip: { urban: 2 }, finish: { signature: 2 } }
  };

  var ANSWER_LABELS = {
    brand: { iphone: 'iPhone', samsung: 'Samsung' },
    2: { protection: 'Máxima proteção', elegance: 'Design elegante', balance: 'Equilíbrio entre proteção e estilo', original: 'Mostrar o visual original do celular' },
    3: { daily: 'Trabalho, faculdade ou uso diário', movement: 'Estou sempre em movimento', travel: 'Viajo com frequência', intense: 'Tenho uma rotina intensa' },
    4: { minimal: 'Minimalista', sophisticated: 'Sofisticado', modern: 'Moderno', different: 'Gosto de chamar atenção' },
    5: { resistance: 'Resistência', camera: 'Proteção para câmera', grip: 'Pegada confortável', finish: 'Acabamento premium' }
  };

  var VALID_DDDS = {
    11: true, 12: true, 13: true, 14: true, 15: true, 16: true, 17: true, 18: true, 19: true,
    21: true, 22: true, 24: true, 27: true, 28: true,
    31: true, 32: true, 33: true, 34: true, 35: true, 37: true, 38: true,
    41: true, 42: true, 43: true, 44: true, 45: true, 46: true, 47: true, 48: true, 49: true,
    51: true, 53: true, 54: true, 55: true,
    61: true, 62: true, 63: true, 64: true, 65: true, 66: true, 67: true, 68: true, 69: true,
    71: true, 73: true, 74: true, 75: true, 77: true, 79: true,
    81: true, 82: true, 83: true, 84: true, 85: true, 86: true, 87: true, 88: true, 89: true,
    91: true, 92: true, 93: true, 94: true, 95: true, 96: true, 97: true, 98: true, 99: true
  };

  function slug(value) {
    return String(value || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .replace(/\+/g, '-plus')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-|-$/g, '');
  }

  function parseList(value) {
    return String(value || '').split(/[\n,]+/).map(function (x) { return x.trim(); }).filter(Boolean);
  }

  function load() {
    try { return JSON.parse(localStorage.getItem(STORAGE)) || {}; } catch (e) { return {}; }
  }

  function save(state) {
    try { localStorage.setItem(STORAGE, JSON.stringify(state)); } catch (e) {}
  }

  function uid() {
    return 'caseid-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 8);
  }

  function readJson(key) {
    try { return JSON.parse(localStorage.getItem(key)) || {}; } catch (e) { return {}; }
  }

  function writeJson(key, value) {
    try { localStorage.setItem(key, JSON.stringify(value)); } catch (e) {}
  }

  function hiddenPost(url, payload) {
    if (!url) return Promise.resolve();
    return new Promise(function (resolve) {
      var iframeName = 'case_id_event_' + Date.now() + '_' + Math.random().toString(36).slice(2, 6);
      var iframe = document.createElement('iframe');
      var form = document.createElement('form');

      iframe.name = iframeName;
      iframe.style.display = 'none';
      iframe.setAttribute('aria-hidden', 'true');

      form.method = 'POST';
      form.action = url;
      form.target = iframeName;
      form.style.display = 'none';

      Object.keys(payload || {}).forEach(function (key) {
        var input = document.createElement('input');
        input.type = 'hidden';
        input.name = key;
        input.value = payload[key] == null ? '' : String(payload[key]);
        form.appendChild(input);
      });

      document.body.appendChild(iframe);
      document.body.appendChild(form);

      iframe.addEventListener('load', function () {
        window.setTimeout(function () {
          if (form.parentNode) form.parentNode.removeChild(form);
          if (iframe.parentNode) iframe.parentNode.removeChild(iframe);
          resolve();
        }, 250);
      });

      form.submit();
      window.setTimeout(resolve, 1400);
    });
  }

  function pageProductTitle() {
    var og = document.querySelector('meta[property="og:title"]');
    var h1 = document.querySelector('h1');
    return (og && og.content) || (h1 && h1.textContent.trim()) || document.title || '';
  }

  function trackJourney(eventName, details) {
    var journey = readJson(JOURNEY_STORAGE);
    var url = String(journey.webhook || '').trim();
    if (!journey.sessionId || !url) return Promise.resolve();

    details = details || {};
    var payload = {
      tipo: 'evento',
      evento: eventName,
      etapa: details.etapa || '',
      detalhe: details.detalhe || '',
      scroll: details.scroll || '',
      produto: details.produto || pageProductTitle(),
      url_produto: details.url_produto || window.location.href,
      sessao: journey.sessionId,
      whatsapp: journey.whatsapp || '',
      marca: journey.marca || '',
      modelo: journey.modelo || '',
      perfil: journey.perfil || '',
      pergunta_1: journey.pergunta_1 || '',
      pergunta_2: journey.pergunta_2 || '',
      pergunta_3: journey.pergunta_3 || '',
      pergunta_4: journey.pergunta_4 || '',
      pergunta_5: journey.pergunta_5 || '',
      pontos_titan: journey.pontos_titan || '',
      pontos_signature: journey.pontos_signature || '',
      pontos_urban: journey.pontos_urban || '',
      pontos_pure: journey.pontos_pure || '',
      pagina: window.location.href,
      data: new Date().toLocaleString('pt-BR')
    };

    return hiddenPost(url, payload);
  }

  function trackOnce(key, eventName, details) {
    var sent = readJson(JOURNEY_EVENTS_STORAGE);
    if (sent[key]) return;
    sent[key] = true;
    writeJson(JOURNEY_EVENTS_STORAGE, sent);
    trackJourney(eventName, details);
  }

  function initJourneyTracking() {
    if (window.__caseIdJourneyReady) return;
    window.__caseIdJourneyReady = true;
    window.CaseIdJourneyTrack = trackJourney;

    if (location.pathname.indexOf('/products/') > -1) {
      trackOnce('view:' + location.pathname, 'pagina_produto_visualizada', {
        etapa: 'Página de vendas',
        detalhe: 'Cliente abriu a página do produto'
      });
    }

    document.addEventListener('click', function (event) {
      var target = event.target;
      var recommended = target.closest && target.closest('.case-id__product-link, .case-id__product-image');
      var buyNow = target.closest && target.closest('.purchase-panel__buy-now');
      var addCart = target.closest && target.closest('.purchase-panel__add-cart');
      var stickyBuy = target.closest && target.closest('[data-sticky-buy]');
      var checkout = target.closest && target.closest('button[name="checkout"], input[name="checkout"], a[href="/checkout"], a[href*="/checkout"], .cart-recap__checkout, .ymp_check_mainBtn');

      if (recommended) {
        var card = recommended.closest('.case-id__product');
        trackJourney('produto_recomendado_clicado', {
          etapa: 'Recomendações do CASE ID',
          detalhe: 'Cliente clicou em um produto recomendado',
          produto: card && card.querySelector('h3') ? card.querySelector('h3').textContent.trim() : '',
          url_produto: recommended.href || ''
        });
      }
      if (buyNow) {
        trackJourney('comprar_agora_clicado', { etapa: 'Página de vendas', detalhe: 'Cliente clicou em Comprar Agora' });
      }
      if (addCart) {
        trackJourney('adicionar_carrinho_clicado', { etapa: 'Página de vendas', detalhe: 'Cliente clicou em Adicionar ao carrinho' });
      }
      if (stickyBuy) {
        trackJourney('comprar_barra_flutuante_clicado', { etapa: 'Página de vendas', detalhe: 'Cliente clicou na barra flutuante de compra' });
      }
      if (checkout) {
        trackJourney('checkout_clicado', { etapa: 'Checkout', detalhe: 'Cliente iniciou ida para o checkout' });
      }
    }, true);

    document.addEventListener('submit', function (event) {
      var submitter = event.submitter;
      var form = event.target;
      if ((submitter && submitter.name === 'checkout') || (form && String(form.action || '').indexOf('/cart') > -1)) {
        trackJourney('formulario_checkout_enviado', { etapa: 'Checkout', detalhe: 'Formulário de checkout enviado' });
      }
    }, true);

    var marks = [25, 50, 75, 100];
    var maxDepth = 0;
    var scrollTimer;
    function checkScroll() {
      var doc = document.documentElement;
      var total = Math.max(1, doc.scrollHeight - window.innerHeight);
      var pct = Math.min(100, Math.round((window.scrollY / total) * 100));
      if (pct <= maxDepth) return;
      maxDepth = pct;
      marks.forEach(function (mark) {
        if (pct >= mark) {
          trackOnce('scroll:' + location.pathname + ':' + mark, 'scroll_' + mark + '_porcento', {
            etapa: location.pathname.indexOf('/products/') > -1 ? 'Página de vendas' : 'Navegação',
            detalhe: mark === 100 ? 'Cliente viu 100% da página' : 'Cliente rolou ' + mark + '% da página',
            scroll: mark + '%'
          });
        }
      });
    }
    window.addEventListener('scroll', function () {
      window.clearTimeout(scrollTimer);
      scrollTimer = window.setTimeout(checkScroll, 180);
    }, { passive: true });
    window.setTimeout(checkScroll, 900);
  }

  function maskWhatsapp(value) {
    var digits = String(value || '').replace(/\D/g, '');
    if (digits.indexOf('55') === 0 && digits.length > 11) digits = digits.slice(2);
    digits = digits.slice(0, 11);
    if (digits.length <= 2) return digits;
    if (digits.length <= 7) return '(' + digits.slice(0, 2) + ') ' + digits.slice(2);
    return '(' + digits.slice(0, 2) + ') ' + digits.slice(2, 7) + '-' + digits.slice(7);
  }

  function normalizeBrazilWhatsapp(value) {
    var digits = String(value || '').replace(/\D/g, '');
    if (digits.indexOf('55') === 0 && digits.length > 11) digits = digits.slice(2);
    var ddd = digits.slice(0, 2);
    if (digits.length !== 11 || digits.charAt(2) !== '9' || !VALID_DDDS[ddd]) return '';
    return '+55' + digits;
  }

  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';

    var config = JSON.parse(root.querySelector('[data-case-config]').textContent);
    var products = JSON.parse(root.querySelector('[data-case-products-json]').textContent);
    var screens = {
      intro: root.querySelector('[data-case-screen="intro"]'),
      quiz: root.querySelector('[data-case-screen="quiz"]'),
      lead: root.querySelector('[data-case-screen="lead"]'),
      loading: root.querySelector('[data-case-screen="loading"]'),
      result: root.querySelector('[data-case-screen="result"]')
    };
    var question = root.querySelector('[data-case-question]');
    var counter = root.querySelector('[data-case-counter]');
    var progress = root.querySelector('[data-case-progress]');
    var recommendations = root.querySelector('[data-case-products]');
    var state = Object.assign({ step: 0, answers: {}, lead: {} }, load());

    function show(name) {
      Object.keys(screens).forEach(function (key) {
        if (screens[key]) screens[key].hidden = key !== name;
      });
    }

    function points() {
      var score = { titan: 0, signature: 0, urban: 0, pure: 0 };
      [2, 3, 4, 5].forEach(function (q) {
        var add = POINTS[q][state.answers[q]] || {};
        Object.keys(add).forEach(function (key) { score[key] += add[key]; });
      });
      return score;
    }

    function result() {
      var score = points();
      var max = Math.max.apply(null, ORDER.map(function (key) { return score[key]; }));
      var tied = ORDER.filter(function (key) { return score[key] === max; });
      var q2 = { protection: 'titan', elegance: 'signature', balance: 'urban', original: 'pure' }[state.answers[2]];
      return tied.indexOf(q2) > -1 ? q2 : tied[0];
    }

    function label(group, value) {
      return (ANSWER_LABELS[group] && ANSWER_LABELS[group][value]) || value || '';
    }

    function setAnswer(step, value) {
      state.answers[step] = value;
      state.step = step < 5 ? step + 1 : 6;
      save(state);
      if (step === 5) renderLead();
      else render();
    }

    function choice(icon, labelText, value, selected, onClick) {
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'case-id__choice' + (selected ? ' is-selected' : '');
      button.innerHTML = '<span class="case-id__choice-icon" aria-hidden="true">' + icon + '</span><span></span>';
      button.lastChild.textContent = labelText;
      button.addEventListener('click', function () { onClick(value); });
      return button;
    }

    function renderQ1() {
      question.innerHTML = '';
      if (!state.answers.brand) {
        var title = document.createElement('h2');
        title.textContent = 'Qual celular você usa?';
        var choices = document.createElement('div');
        choices.className = 'case-id__choices';
        choices.appendChild(choice('', 'iPhone', 'iphone', false, function (value) {
          state.answers.brand = value;
          save(state);
          render();
        }));
        choices.appendChild(choice('S', 'Samsung', 'samsung', false, function (value) {
          state.answers.brand = value;
          save(state);
          render();
        }));
        question.append(title, choices);
        return;
      }

      var heading = document.createElement('div');
      heading.className = 'case-id__model-heading';
      var h = document.createElement('h2');
      h.textContent = 'Qual é o modelo do seu ' + (state.answers.brand === 'iphone' ? 'iPhone' : 'Samsung') + '?';
      var change = document.createElement('button');
      change.type = 'button';
      change.className = 'case-id__change-brand';
      change.textContent = 'Trocar marca';
      change.addEventListener('click', function () {
        delete state.answers.brand;
        delete state.answers.model;
        save(state);
        render();
      });
      heading.append(h, change);

      var models = parseList(state.answers.brand === 'iphone' ? config.iphoneModels : config.samsungModels);
      var choices = document.createElement('div');
      choices.className = 'case-id__choices';
      models.forEach(function (model) {
        choices.appendChild(choice('⌁', model, model, state.answers.model === model, function (value) {
          state.answers.model = value;
          state.answers[1] = state.answers.brand;
          state.step = 2;
          save(state);
          render();
        }));
      });
      question.append(heading, choices);
    }

    function renderStandard(step) {
      question.innerHTML = '';
      var data = QUESTIONS[step];
      var title = document.createElement('h2');
      title.textContent = data.title;
      var choices = document.createElement('div');
      choices.className = 'case-id__choices';
      data.options.forEach(function (item) {
        choices.appendChild(choice(item[0], item[1], item[2], state.answers[step] === item[2], function (value) {
          setAnswer(step, value);
        }));
      });
      question.append(title, choices);
    }

    function render() {
      recommendations.hidden = true;
      if (state.step === 0) {
        show('intro');
        return;
      }
      if (state.step === 6 && state.answers.model && !(state.lead && state.lead.whatsapp)) {
        renderLead();
        return;
      }
      if (state.step === 7 && state.answers.model) {
        showResult();
        return;
      }
      state.step = Math.min(5, Math.max(1, state.step || 1));
      show('quiz');
      counter.textContent = 'Pergunta ' + state.step + ' de 5';
      progress.style.width = (state.step * 20) + '%';
      if (state.step === 1) renderQ1();
      else renderStandard(state.step);
    }

    function renderLead() {
      var screen = screens.lead;
      if (!screen) {
        loading();
        return;
      }
      state.step = 6;
      save(state);
      recommendations.hidden = true;
      show('lead');

      var input = screen.querySelector('[data-case-whatsapp]');
      var error = screen.querySelector('[data-case-whatsapp-error]');
      var button = screen.querySelector('[data-case-whatsapp-submit]');

      if (input && state.lead && state.lead.raw) input.value = state.lead.raw;
      if (error) error.hidden = true;
      if (input && !input.dataset.maskReady) {
        input.dataset.maskReady = 'true';
        input.addEventListener('input', function () {
          input.value = maskWhatsapp(input.value);
          if (error) error.hidden = true;
        });
        input.addEventListener('keydown', function (event) {
          if (event.key === 'Enter') {
            event.preventDefault();
            submitLead();
          }
        });
      }
      if (button && !button.dataset.ready) {
        button.dataset.ready = 'true';
        button.addEventListener('click', submitLead);
      }
      if (input) window.setTimeout(function () { input.focus(); }, 120);
    }

    function leadPayload(profileKey, whatsapp) {
      var score = points();
      var profile = PROFILES[profileKey];
      var existingJourney = readJson(JOURNEY_STORAGE);
      var sessionId = existingJourney.sessionId || uid();
      return {
        tipo: 'lead',
        evento: 'quiz_finalizado',
        etapa: 'CASE ID',
        detalhe: 'Cliente preencheu o quiz e informou o WhatsApp',
        origem: 'CASE ID',
        sessao: sessionId,
        whatsapp: whatsapp,
        marca: label('brand', state.answers.brand),
        modelo: state.answers.model || '',
        perfil: profile.name,
        pergunta_1: label('brand', state.answers.brand) + ' / ' + (state.answers.model || ''),
        pergunta_2: label(2, state.answers[2]),
        pergunta_3: label(3, state.answers[3]),
        pergunta_4: label(4, state.answers[4]),
        pergunta_5: label(5, state.answers[5]),
        pontos_titan: score.titan,
        pontos_signature: score.signature,
        pontos_urban: score.urban,
        pontos_pure: score.pure,
        pagina: window.location.href,
        data: new Date().toLocaleString('pt-BR')
      };
    }

    function leadBody(profileKey, whatsapp) {
      var payload = leadPayload(profileKey, whatsapp);
      return [
        'CASE ID™ - Novo preenchimento',
        '',
        'WhatsApp: ' + payload.whatsapp,
        'Marca: ' + payload.marca,
        'Modelo: ' + payload.modelo,
        'Perfil encontrado: ' + payload.perfil,
        '',
        'Respostas do quiz:',
        '1. Celular: ' + payload.pergunta_1,
        '2. Mais importante: ' + payload.pergunta_2,
        '3. Rotina: ' + payload.pergunta_3,
        '4. Estilo: ' + payload.pergunta_4,
        '5. Característica: ' + payload.pergunta_5,
        '',
        'Pontuação:',
        'Titan: ' + payload.pontos_titan,
        'Signature: ' + payload.pontos_signature,
        'Urban: ' + payload.pontos_urban,
        'Pure: ' + payload.pontos_pure,
        '',
        'Página de origem: ' + payload.pagina,
        'Data do envio: ' + payload.data
      ].join('\n');
    }

    function sendLeadToWebhook(profileKey, whatsapp) {
      var url = String(config.leadWebhook || '').trim();
      if (!url) return Promise.resolve();
      return hiddenPost(url, leadPayload(profileKey, whatsapp));
    }

    function saveLeadOnCart(profileKey, whatsapp) {
      var payload = leadPayload(profileKey, whatsapp);
      return fetch('/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          attributes: {
            'CASE ID - WhatsApp': payload.whatsapp,
            'CASE ID - Modelo': payload.modelo,
            'CASE ID - Perfil': payload.perfil,
            'CASE ID - Mais importante': payload.pergunta_2,
            'CASE ID - Rotina': payload.pergunta_3,
            'CASE ID - Estilo': payload.pergunta_4,
            'CASE ID - Característica': payload.pergunta_5
          }
        })
      });
    }

    function sendLead(whatsapp) {
      var profileKey = result();
      var form = new FormData();
      form.append('form_type', 'contact');
      form.append('utf8', '✓');
      form.append('contact[name]', 'Lead CASE ID');
      form.append('contact[email]', LEAD_EMAIL);
      form.append('contact[phone]', whatsapp);
      form.append('contact[CASE ID]', PROFILES[profileKey].name);
      form.append('contact[body]', leadBody(profileKey, whatsapp));

      var contactRequest = fetch('/contact', {
        method: 'POST',
        body: form,
        credentials: 'same-origin',
        headers: { 'Accept': 'text/html' }
      });

      return Promise.allSettled([
        sendLeadToWebhook(profileKey, whatsapp),
        saveLeadOnCart(profileKey, whatsapp),
        contactRequest
      ]);
    }

    function submitLead() {
      var screen = screens.lead;
      var input = screen && screen.querySelector('[data-case-whatsapp]');
      var error = screen && screen.querySelector('[data-case-whatsapp-error]');
      var button = screen && screen.querySelector('[data-case-whatsapp-submit]');
      var whatsapp = normalizeBrazilWhatsapp(input ? input.value : '');

      if (!whatsapp) {
        if (error) {
          error.textContent = 'Digite um WhatsApp brasileiro válido com DDD. Exemplo: (11) 91234-5678.';
          error.hidden = false;
        }
        if (input) input.focus();
        return;
      }

      state.lead = {
        raw: input ? input.value : whatsapp,
        whatsapp: whatsapp,
        sentAt: new Date().toISOString()
      };
      save(state);

      var profileKey = result();
      var journey = Object.assign({}, leadPayload(profileKey, whatsapp), {
        webhook: String(config.leadWebhook || '').trim(),
        startedAt: new Date().toISOString()
      });
      writeJson(JOURNEY_STORAGE, journey);
      writeJson(JOURNEY_EVENTS_STORAGE, {});

      if (button) {
        button.disabled = true;
        button.textContent = 'Enviando...';
      }

      sendLead(whatsapp).catch(function () {
        state.lead.sendFailed = true;
        save(state);
      }).finally(function () {
        if (button) {
          button.disabled = false;
          button.textContent = 'Ver minhas cases selecionadas';
        }
        loading();
      });
    }

    function loading() {
      show('loading');
      save(state);
      window.setTimeout(function () {
        state.step = 7;
        save(state);
        showResult();
      }, 2000);
    }

    function showResult() {
      var key = result();
      var profile = PROFILES[key];
      show('result');
      root.querySelector('[data-case-profile]').textContent = profile.icon + ' ' + profile.name;
      root.querySelector('[data-case-description]').textContent = profile.description;
    }

    function compact(value) {
      return slug(value).replace(/-/g, '');
    }

    function searchable(item) {
      return [item.title || ''].concat(item.tags || []).concat(item.collections || []).join(' ');
    }

    function tagMatches(value, accepted) {
      var s = slug(value);
      var c = compact(value);
      return accepted.some(function (term) {
        var st = slug(term);
        var ct = compact(term);
        return s === st || c === ct || s.indexOf(st) > -1 || c.indexOf(ct) > -1;
      });
    }

    function hasProfile(item, key) {
      var accepted = [key, 'perfil-' + key, 'perfil:' + key, 'perfil ' + key, 'case-id-' + key, 'case id ' + key, 'caseid-' + key, 'linha-' + key, 'linha:' + key, 'linha ' + key];
      return tagMatches(searchable(item), accepted);
    }

    function hasModel(item, model, brand) {
      var key = slug(model);
      var plain = compact(model);
      var brandKey = slug(brand);
      var accepted = [key, plain, 'modelo-' + key, 'modelo:' + key, 'modelo ' + key, 'modelo-' + plain, 'modelo:' + plain, 'compatibilidade-' + key, 'compatibilidade:' + key, 'case-' + key, 'celular-' + key, 'aparelho-' + key];
      if (brandKey === 'iphone') accepted = accepted.concat(['iphone', 'iphones', 'ios', 'apple', 'modelo-iphone', 'compatibilidade-iphone', 'celular-iphone']);
      if (brandKey === 'samsung') accepted = accepted.concat(['samsung', 'galaxy', 'modelo-samsung', 'compatibilidade-samsung', 'celular-samsung']);
      return tagMatches(searchable(item), accepted);
    }

    function productCard(item) {
      var card = document.createElement('article');
      card.className = 'case-id__product';
      var image = item.image ? '<img src="' + item.image + '" alt="" loading="lazy">' : '';
      card.innerHTML = '<a class="case-id__product-image"></a><div class="case-id__product-info"><h3></h3><div class="case-id__product-price"><strong></strong><s></s></div><a class="case-id__product-link">VER PRODUTO</a></div>';
      var links = card.querySelectorAll('a');
      links.forEach(function (linkEl) { linkEl.href = item.url; });
      card.querySelector('.case-id__product-image').innerHTML = image;
      card.querySelector('h3').textContent = item.title;
      card.querySelector('strong').textContent = item.price;
      var compare = card.querySelector('s');
      compare.textContent = item.comparePrice || '';
      compare.hidden = !item.comparePrice;
      return card;
    }

    function showProducts() {
      var profile = result();
      var matched = products.filter(function (item) {
        return hasProfile(item, profile) && hasModel(item, state.answers.model, state.answers.brand);
      }).slice(0, Number(config.productLimit) || 8);
      var grid = root.querySelector('[data-case-product-grid]');
      grid.innerHTML = '';
      matched.forEach(function (item) { grid.appendChild(productCard(item)); });
      root.querySelector('[data-case-device]').textContent = state.answers.model;
      root.querySelector('[data-case-match-summary]').textContent = matched.length + ' ' + (matched.length === 1 ? 'opção compatível' : 'opções compatíveis') + ' com o perfil ' + PROFILES[profile].name + '.';
      root.querySelector('[data-case-empty]').hidden = matched.length > 0;
      recommendations.hidden = false;
      trackJourney('recomendacoes_case_id_visualizadas', {
        etapa: 'Recomendações do CASE ID',
        detalhe: 'Cliente clicou para ver as recomendações',
        produto: matched.length + ' produtos encontrados'
      });
      recommendations.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    root.querySelector('[data-case-start]').addEventListener('click', function () {
      state.step = state.answers.model ? Math.max(2, state.step || 2) : 1;
      save(state);
      render();
    });

    root.querySelectorAll('[data-case-back]').forEach(function (backButton) {
      backButton.addEventListener('click', function () {
        if (state.step === 6) state.step = 5;
        else if (state.step <= 1) state.step = 0;
        else state.step -= 1;
        save(state);
        render();
      });
    });

    root.querySelector('[data-case-restart]').addEventListener('click', function () {
      state = { step: 1, answers: {}, lead: {} };
      try { localStorage.removeItem(STORAGE); } catch (e) {}
      render();
    });

    root.querySelector('[data-case-recommendations]').addEventListener('click', showProducts);
    render();
  }

  function start() {
    initJourneyTracking();
    document.querySelectorAll('[data-case-id-root]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', start);
})();
